import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/login.scss';

export class PasswordRecovery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ''
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  async formSubmit(e) {
    e.preventDefault();

    let response = await window.doRequest('POST', {
      action: 'recoverPassword',
      email: this.state.email
    });

    if (response.status) {
      window.alert(response.message);
      this.props.history.push('/login');
    } else
        window.alert(response.message);
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="login">
          <div className="container password-recovery">
            <h1 className="title">Recuperação de senha</h1>
            <p>Preencha os dados abaixo.</p>
            <form onSubmit={(e) => { this.formSubmit(e) }}>

              <input
                type="mail"
                placeholder="E-mail"
                name="email"
                value={this.state.email}
                onChange={(e) => {this.handleChange(e)}}
                required>
              </input>

              <div className="btn-container">
                <button className="btn filled" type="submit">Enviar</button>
              </div>

            </form>
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default PasswordRecovery
